import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { SearchFlagsService } from '@app/search/services';
import {
  SearchSubmitMethod,
  SearchTrackerService,
} from '@app/search/services/search-tracker.service';
import { RelatedSkill } from '@app/search/services/search.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-search-related-skills',
  templateUrl: './search-related-skills.component.html',
  styleUrls: ['./search-related-skills.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchRelatedSkillsComponent {
  @Input() public skills: RelatedSkill[];
  @Input() public isLoading: boolean;

  @Output() public skillSelected = new EventEmitter<string>();

  public i18n = this.translateService.instant([
    'LearningSearch_SuggestedSearches',
  ]);

  constructor(
    private searchTrackerService: SearchTrackerService,
    private searchFlagsService: SearchFlagsService,
    private translateService: TranslateService
  ) {}

  public get showSearchLayoutRedesign(): boolean {
    return this.searchFlagsService.showSearchLayoutRedesign;
  }

  public get hasRelatedSkills(): boolean {
    return this.skills.length > 0;
  }

  public getTooltip(skill: string) {
    return this.translateService.instant('Core_RelatedSkillTooltip', {
      skillName: skill,
    });
  }

  public handleClick(skill: string, index: number) {
    this.trackLinkClick(skill, index);
    this.skillSelected.emit(skill);
  }

  // May seem a little excessive, but it prevents flashing as list is re-rendered
  public trackByFn(index: number, item: RelatedSkill): string {
    return item.term;
  }

  private trackLinkClick(skill: string, index: number) {
    this.searchTrackerService.setSearchData({
      submitMethod: SearchSubmitMethod.suggestedTermClicked,
    });

    const allSkills = this.skills.map((item) => item.term);

    this.searchTrackerService.suggestedTermOpened(skill, index, allSkills);
  }
}
